import { Suspense } from 'react'

import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { WorkspacesBreadcrumbs } from '../WorspacesBreadcrumbs'
import { useCurrentWorkspace } from '../useCurrentWorkspace'
import { useRestClient } from '@/contexts/QueryProvider'
import { DataTable } from '@/components/ui/DataTable'
import { workspaceEventSchedulerColumns } from './WorkspaceEventSchedulerTable/workspaceEventSchedulerColumns'
import { Button } from '@/components/shadcn/button'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { EventSchedulerForm } from '../Forms/EventSchedulerForm'

export function WorkspaceEventSchedulerPage() {
  return (
    <>
      <WorkspacesBreadcrumbs title="Event Scheduler" />
      <QueryErrorBoundary errorMessage="Failed to fetch data templates">
        <Suspense fallback={<DataTableLoading />}>
          <WorkspaceEventSchedulerPanelContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function WorkspaceEventSchedulerPanelContent() {
  const { workspaceId } = useCurrentWorkspace()
  const { getSchedulerApiGetSchedules } = useRestClient()
  const { data: schedules } = getSchedulerApiGetSchedules.useSuspenseQuery({path: {workspaceId}})
  // const { data: summary } = useGetTemplatesSummary({ appId: app_id, projectId: project_id })

  return (
    <TablePageContainer>
      <DataTable
        columns={workspaceEventSchedulerColumns}
        data={schedules ?? []}
        action={
          <EventSchedulerForm
            sheetTitle="Add a new scheduler"
            sheetTrigger={
              <Button size="lg" variant="outline">
                <IconPlusOutline className="mr-2" />
                Add scheduler
              </Button>
            }
          />
        }
        defaultSortColumnId="createdAt"
        defaultSortDesc
      />
    </TablePageContainer>
  )
}
